/** Small status dot with optional pulse. Matches
 *  design-handoff/project/components.jsx:StatusDot.
 */
export function StatusDot({
  color = "var(--ink-3)",
  pulse = false,
  size = 8,
}: {
  color?: string;
  pulse?: boolean;
  size?: number;
}) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        boxShadow: pulse ? `0 0 0 0 ${color}` : "none",
        animation: pulse ? "sd-pulse 1.6s ease-out infinite" : "none",
      }}
    >
      <style>{`
        @keyframes sd-pulse {
          0%   { box-shadow: 0 0 0 0 currentColor; }
          70%  { box-shadow: 0 0 0 8px rgba(0,0,0,0); }
          100% { box-shadow: 0 0 0 0 rgba(0,0,0,0); }
        }
      `}</style>
    </span>
  );
}
